/* unplugin-vue-components disabled */import script from "./StarLevelCount.vue?vue&type=script&setup=true&lang=js"
export * from "./StarLevelCount.vue?vue&type=script&setup=true&lang=js"

import "./StarLevelCount.vue?vue&type=style&index=0&id=504313ed&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504313ed"]])

export default __exports__